import React from "react";
import ProfileCard from "./ProfileCard";
import InlineCitationText from "./InlineCitationText";

const ProfileInfo = ({ data, type, title, description, secondHeading }) => {
  return (
    <div className="flex flex-col items-start gap-5 w-full h-fit">
      {/* header/card header  */}
      <div className="flex flex-col gap-2.5 w-full">
        <div className="flex flex-col gap-0.5 items-start font-normal font-inter text-[0.783rem] leading-5">
          <h1 className="font-medium text-gray-800">{title}</h1>
          <p className="text-gray-500">{description}</p>
        </div>
        <div className="grid w-full auto-cols-[363px] grid-flow-col gap-6 overflow-x-auto border-b border-b-[var(--border-color-light)] pb-5">
          {(type === "challenges"
            ? data?.key_challenges
            : data?.key_priorities
          )?.map((challenge, i) => {
            return <ProfileCard key={i} cardData={challenge} />;
          })}
        </div>
      </div>

      <div
        className={`flex flex-col items-start gap-2.5 text-[0.783rem] font-normal leading-5   ${data?.our_solutions?.length > 0
          ? "border-b-[1px] border-b-[var(--border-color-light)] pb-6 w-full"
          : "w-full"
          }`}
      >
        <h1 className="font-medium text-gray-800">{secondHeading}</h1>
        {type === "challenges" ? (
          <ul>
            {data?.recent_investments?.map((investment, i) => {
              return (
                <li
                  key={i}
                  className="font-normal text-gray-700 relative ml-1.5 pl-3 before:content-[''] before:absolute before:left-0 before:top-2 before:w-1 before:h-1 before:rounded-full before:bg-gray-700"
                >
                  <InlineCitationText>{investment}</InlineCitationText>
                </li>
              );
            })}{" "}
          </ul>
        ) : (
          <p className="text-gray-700 font-normal">
            <InlineCitationText>{data?.revenue_report}</InlineCitationText>
          </p>
        )}
      </div>
    </div>
  );
};

export default ProfileInfo;
